import { useQuery } from "@tanstack/react-query";
import { API } from "../data/site";
import { POSTS as FALLBACK } from "../data/blog";

export const usePosts = (includeDrafts = false) =>
  useQuery({
    queryKey: ["posts", includeDrafts],
    queryFn: async () => {
      const url = includeDrafts ? `${API}/admin/posts` : `${API}/posts`;
      const res = await fetch(url, { credentials: includeDrafts ? "include" : "omit" });
      if (!res.ok) throw new Error("Failed to load posts");
      const data = await res.json();
      return data.posts?.length ? data.posts : FALLBACK.filter((p) => includeDrafts || p.published);
    },
    initialData: includeDrafts ? undefined : FALLBACK,
  });
